<template>
	<div class="box">
		<Header navbar="hearKnowledge"></Header>

		<div class="DetaiJx">
			<div class="Detai-xq">
				<div class="fh" @click="goHome"><span style="color: #fff;">
						<i class="el-icon-arrow-left"></i>返回</span></div>

				<div class="Detai-js">
					<div class="Detai-js-img">
						<img style="width: 100%;height: 100%;" :src="detail.coverUrl" alt="">
					</div>
					<div class="Detai-js-con">
						<div class="Detai-js-con-li1">

							{{ detail.name }}
						</div>
						<div class="Detai-js-con-li2">{{ detail.description
						}}
						</div>
						<div class="Detai-js-con-jd">
							<div style="display: flex;height: 40px;line-height:45px;color: #fff;">
								<el-progress :color="customColor" :stroke-width="15"
									style="width: 60%;;margin-top: 15px;margin-right: 30px;" :show-text="false"
									:percentage="detail.studyProgress"></el-progress>
								学习进度 : {{ detail.studyProgress }}% &nbsp;


								<el-popover placement="right" width="290" trigger="hover">
									<div>专题学习进度规则：<br> （1）课程：每个课程观看进度均达100%<br> （2）直播：每场均有过观看直播/回放记录 <br>（3）考试：至少有一次考试记录
										<br>(注：学习进度数据最晚将于12小时内进行更新)
									</div>

									<i slot="reference" class="el-icon-question"></i>
								</el-popover>

							</div>

						</div>
						<div class="Detai-js-con-li3">
							<div v-if="detail.courseCount">包含课程 {{ detail.courseCount }}门</div>
							<div v-if="detail.courseTotalTime">总课程时长 {{ detail.courseTotalTime }}</div>
							<div v-if="detail.liveCount">包含直播 {{ detail.liveCount }}门</div>
							<div v-if="detail.paperCount" style="border: none;">考试 {{ detail.paperCount }}场</div>
						</div>
					</div>
				</div>

			</div>
		</div>

		<el-button v-if="this.userType == 2" type="danger"
			style="background: #FF9645;position: absolute;left: 65%;top: 230px;" @click="toBg">报告查看</el-button>

		<div class="ztjs">
			<div :class="active == 1 ? 'active' : ''" @click="active = 1">专题介绍</div>
			<div :class="active == 2 ? 'active' : ''" @click="active = 2">专题学习路径</div>
		</div>
		<div class="DetailsBox">
			<div v-if="active == 1">
				<div style="width: 100%;min-height: 800px;;background: #EDEDED;" v-html="detail.remark"
					v-if="detail.remark">
				</div>
				<div v-else style="text-align: center;line-height: 200px; font-size: 20px;">
					暂无专题介绍
				</div>
			</div>
			<div v-else class="ztxx">
				<div class="left" ref="left"><br>
					<div class="ztBZ" v-for="(item, index) in detail.list" :key="item.specId" :id="'key' + index">
						<div class="zy">
							<div class="ids">{{ index + 1 }}</div>&nbsp;
							<div> <img src="../../assets/img/bz1.png" alt=""></div>
						</div>
						<div class="title">&nbsp;&nbsp;&nbsp;{{ item.stageName }}</div>
						<div class="recordList" style="cursor: pointer;" @click="lkxx(k)" v-for="k in item.recordList"
							:key="k.resourceId">
							<div class="recordList_box">
								<div class="recordList_box_img">
									<img :src="k.coverUrl" alt="">
								</div>
								<div class="recordList_box_con">
									<div class="recordList_box_con1">
										<div class="con-type">视频</div>
										<div class="con-name">{{ k.title }}</div>
									</div>
									<div class="recordList_box_con2">上次学习：{{ k.updateTime ? k.updateTime : "未开始" }}</div>
									<div class="recordList_box_con3">已学习：{{ k.studyProgress ? k.studyProgress : '0' }}%
									</div>

								</div>
								<div class="recordList_box_btn">{{ k.studyProgress ? '继续学习' : '立即学习' }}
								</div>
							</div>
						</div>
						<div class="recordList" style="cursor: pointer;" @click="ckzb(k)" v-for="k in item.liveList"
							:key="k.resourceId">
							<div class="recordList_box">
								<div class="recordList_box_img">
									<img :src="k.coverUrl" alt="">
								</div>
								<div class="recordList_box_con">
									<div class="recordList_box_con1">
										<div class="con-type con-type1">直播</div>
										<div class="con-name">{{ k.title }}</div>
									</div>
									<div class="recordList_box_con2">直播时间：{{ k.startTime }}</div>
									<div class="recordList_box_con3">讲师：{{ k.teacherName }}
									</div>

								</div>
								<div class="recordList_box_btn">

									<!-- <span v-if="k.liveStatus == 0 || k.liveStatus == 1">查看直播</span>
									<span v-if="k.liveStatus == 2">回放生成中</span>
									<span v-if="k.liveStatus == 3">查看回放</span> -->

									<span v-if="k.liveStatus == 0">未开始</span>
									<span v-if="k.liveStatus == 1">进入直播</span>
									<span v-if="k.liveStatus == 2">回放生成中</span>
									<span v-if="k.liveStatus == 3">查看回放</span>
								</div>
							</div>
						</div>
						<div class="recordList" v-for="(k, i) in item.paperList" :key="k.resourceId">
							<div class="recordList_box">
								<div class="recordList_box_img recordList_box_img1">
									<img src="../../assets/img/ksjd.png" alt="">
								</div>
								<div class="recordList_box_con">
									<div class="recordList_box_con1" style="margin-bottom: 20px;">
										<div class="con-name ">阶段测试</div>
									</div>
									<div class="recordList_box_con2 ">{{ k.title }}</div>


								</div>
								<div class="recordList_box_btn recordList_box_btn1 recordList_box_btn2"
									v-if="k.paperStatus == 0" @click="ksks(k)">
									<span v-if="k.paperStatus == 0">
										<!-- 未开始 -->
										等待开放
									</span>



								</div>
								<div class="recordList_box_btn recordList_box_btn1 " @click="ksks(k)"
									v-if="k.paperStatus == 1">

									<span>
										<!-- 开放中 -->
										开始做题
									</span>


								</div>
								<div class="recordList_box_btn recordList_box_btn1 recordList_box_btn2" @click="ksks(k)"
									v-if="k.paperStatus == 2">
									<span v-if="k.paperStatus == 2">
										<!-- 已关闭 -->
										试卷关闭
									</span>

								</div>
							</div>
						</div>


					</div>
					<div style="margin-bottom: 100px;"></div>
				</div>
				<div :class="isFixed ? 'right right1' : 'right'">
					<ul>
						<li :class="liftActive == k ? 'liftActive liftActive1' : 'liftActive1'"
							v-for="(item, k) in detail.list" :key="item.specId" @click="lift(k)">
							{{ item.stageName }}
						</li>
					</ul>
				</div>
			</div>


		</div>

	</div>
</template>

<script>

import Header from "@/components/Header.vue";


import {
	getMySpecPlanDetail, checkSpecReport

} from "@/api/index.js";

export default {

	name: "jxzt",
	components: {
		Header,
	},
	data() {
		return {
			isFixed: false,
			liftActive: 0,
			customColor: '#FF9645',
			centerDialogVisible: false,
			userType: null,
			deptList: [],
			detail: {


			}, active: 1,
			homeSteps: {
				shifts: {
					intro: '为提供更专业有效的学习，现已为用户新增了“专题学习”模块，快去看看吧~~。',

				},

			},

			timeTop: null,
			active: 2,
			id: null, deptId: null, token: null, times: null,
		};
	},
	created() {


		var token = window.localStorage.getItem('token');
		var user = window.localStorage.getItem('user');
		var dept = window.localStorage.getItem('TopDeptId');
		if (token) {
			this.token = token;
		}
		if (dept) {
			this.deptId = dept;
		}
		if (user) {
			this.userType = JSON.parse(user).role
		}



		this.id = this.$route.params.id
		this.getDetail()

	},
	computed: {
		grgm() {
			// 该函数将在依赖的响应式属性变化时重新执行
			return this.deptList.filter(item => {

				return item.deptId == 177
			})
		},
		qygm() {

			if (this.deptList.length == 2) {
				var a = this.deptList.filter(item => {

					return item.deptId !== 177
				})

				return a[0].perm
			} else {
				return ''
			}

		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);

	},
	methods: {
		toBg() {
			checkSpecReport({
				specId: this.id

			}, {
				Authorization: this.token ? this.token : "",
				DeptId: this.deptId ? this.deptId : "",
			}).then(res => {
				if (res.code == 200) {
					this.$router.push(`/xxbg/${this.id}`)
				} else {
					this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		lift(k) {
			this.liftActive = k
			document.documentElement.scrollTop = document.body.scrollTop = this.detail.list[k].scrollTop
		},
		getDetail() {
			getMySpecPlanDetail({
				specId: this.id
			}, {
				Authorization: this.token ? this.token : "",
			})
			this.$router.push(`/xxbg/${this.id}`)
		},
		handleScroll(e) {

			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop



			if (scrollTop > 310) {
				this.isFixed = true
			} else {
				this.isFixed = false
			}

		},
		//开始考试操作
		ksks(row) {
			let _this = this
			//paperStatus试卷状态（0：未开始 1：开放中 2：已关闭）
			switch (row.paperStatus) {
				case 0:
					console.log(0);
					this.$message({
						message: '该试卷暂未上线，不支持做题，敬请期待!',
						type: 'warning'
					});
					//
					break;
				case 1:
					//examCount 0=未考试 >0=考过

					console.log(row.examCount, 'row.examCount')
					if (row.examCount == 0) {
						this.$router.push({
							path: `/exam/${row.paperId}`,
							query: {
								ksid: this.id
							}
						});
					} else {
						this.$confirm("<div style='line-height:18px'>您已提交过考试<br/>可查看上次做题或重新考试！</div>", '提示', {
							distinguishCancelAndClose: true, dangerouslyUseHTMLString: true, distinguishCancelAndClose: true, center: true,

							cancelButtonText: '查看上次做题',
							confirmButtonText: '重新考试',
						})
							.then(() => {
								this.$router.push({
									path: `/exam/${row.paperId}`,
									query: {
										ksid: _this.id
									}
								});
							})
							.catch(action => {
								if (action == 'cancel') {
									this.$router.push({
										path: `/apper`,
										query: {
											ksid: _this.id,
											chaName: row.title,
											apperId: row.paperId,
											jxLoadingAll: true,
											userPaperId: row.userPaperId,
										}
									});
								}

							});
					}
					break;
				case 2:
					//该试卷开放时间已结束
					this.$message({
						message: '该试卷开放时间已结束!',
						type: 'warning'
					});
					console.log(2);
					break;

			}
		},
		//直播按钮操作
		ckzb(row) {
			console.log(row)
			this.$router.push({ path: `/courseDetail/live-learn/${row.resourceId}/${this.deptId}/1`, query: { courseType: row.resourceType } });

		},
		//录播操作
		lkxx(row) {
			console.log(row)
			//row.resourceTyp
			this.$router.push(`/courseDetail/record-learn/${row.resourceId}/${this.deptId}/${1}`);


		},
		lift(k) {
			this.liftActive = k
			let targetEle = document.querySelector(`#key${k}`)
			//document.documentElement.scrollTop = targetEle.offsetTop - 120



			targetEle.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		},
		gmQy(row) {
			if (row.perm == 0) {
				console.log(row, '111111111')
				this.centerDialogVisible = false
			}

		},

		purchase() {
			var loginInfo = window.localStorage.getItem("user");
			if (!loginInfo) {
				this.$message.error("请先登录");
				this.$router.push("/login");
				return false;
			}
			//active==1个人 active==2企业
			if (this.active == 1) {

			} else {
				if (this.deptList.length == 1) {
					this.$message({

						dangerouslyUseHTMLString: true,
						message: "<div >您还未开通企业服务，可联系课程顾问获取帮助！</div><br/><div>热线电话400-600-8999</div>"
					});
				} else {
					this.centerDialogVisible = true
				}
			}
		},
		getDetail() {
			getMySpecPlanDetail(

				{

					specId: this.id

				}, {
				Authorization: this.token ? this.token : "",
				DeptId: this.deptId ? this.deptId : "",
			},
			).then(res => {
				if (res.code == 0) {
					console.log(res, 'useruser')
					//this.deptList = res.data.deptList;
					this.detail = res.data
				}

			})
		},
		goHome() {

			this.$router.push("/index");
			//history.back();
			//this.$router.push("-1");

		},
	},
	watch: {

	},

};
</script>

<style scoped lang="less">
.box {
	width: 100%;
	overflow-y: auto;
	height: auto;
}

.intro-tooltip {
	.introjs-tooltip-header {
		padding-left: 12px;
		padding-right: 12px;
		display: none !important;
		;
	}

	.introjs-tooltip-title {
		font-size: 14px;
	}

	.introjs-skipbutton {
		font-size: 14px;
	}

	.introjs-tooltiptext {
		font-size: 12px;
		padding: 12px;
	}

	.introjs-tooltipbuttons {
		.introjs-button {
			font-size: 12px;
			padding: 3px 5px;
		}
	}
}

.introjs-disableInteraction {
	color: red !important;
}

.qylist {
	cursor: pointer;
	height: 50px;
	width: 100%;
	line-height: 50px;
	margin: 30px 0;
	text-align: center;
	font-size: 20px;
	border-radius: 5px;
	border: 1px solid #000;
	position: relative;

	.ygm {
		position: absolute;
		right: 0;
		top: -14px;
		width: 60px;
		height: 25px;
		line-height: 25px;
		background: orange;
		color: #fff;
		font-size: 13px;
	}

}

.qylist1 {
	background: #545353;
	color: #fff;
}

.DetaiJx {
	width: 100%;
	height: 320px;
	margin: 0;
	padding: 0;
	padding-top: 100px;
	background-image: url('../../assets/img/bg1.png');
	background-repeat: no-repeat;
	background-origin: center;
	background-size: cover;

	.Detai-xq {
		width: 1200px;
		height: 100%;

		margin: 0 auto;
		display: flex;
		position: relative;

		.fh {
			cursor: pointer;
			position: absolute;
			font-size: 20px;
			font-weight: 500;
			top: 20px;

			i {
				font-size: 20px;
			}
		}

		.Detai-js {
			margin-top: 75px;
			width: 980px;
			height: 194px;

			display: flex;

			.Detai-js-img {
				width: 165px;
				height: 194px;
				border-radius: 8px;
				overflow: hidden;
				margin-right: 36px;
			}

			.Detai-js-con {
				width: 700px;
				height: 100%;

				.Detai-js-con-li1 {
					width: 700px;
					height: 33px;
					line-height: 33px;

					font-weight: 500;
					font-size: 24px;
					color: #FFFFFF;
					margin-bottom: 20px;
					overflow: hidden;
					/* 隐藏超出部分的内容 */
					white-space: nowrap;
					/* 禁止文本换行 */
					text-overflow: ellipsis;
					/* 在文本末尾添加省略号 */
				}

				.Detai-js-con-li2 {
					height: 40px;
					width: 700px;
					font-weight: 400;
					font-size: 16px;
					color: #FFFFFF;
					line-height: 22px;
					margin-bottom: 20px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					/* 设置最大显示行数 */
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
				}

				.Detai-js-con-li3 {
					display: flex;
					width: 100%;
					height: 18px;

					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 20px;


					div {
						padding-right: 20px;
						margin-right: 40px;
						border-right: 1px solid #fff;
					}



				}

				.Detai-js-con-jd {
					height: 50px;
					margin-bottom: 10px;
					width: 100%;

					div>i {
						cursor: pointer;
						font-size: 20px;
						margin-top: 10px;
						margin-left: 20px;
						color: #FFFFFF;
					}

				}
			}
		}


	}
}


.ztjs {
	width: 1200px;


	height: 33px;
	font-weight: 600;
	font-size: 24px;
	color: #333333;
	line-height: 33px;
	margin: 0 auto;
	margin-top: 20px;
	margin-bottom: 10px;
	display: flex;

	div {
		cursor: pointer;
		margin-right: 50px;
	}

	.active {
		color: #0F6CF5;
	}
}

.DetailsBox {
	width: 1200px;
	min-height: 800px;
	margin: 0 auto;
	overflow: auto;

	margin-bottom: 100px;

	.ztxx {
		display: flex;
		width: 100%;

		.left {
			width: 1023px;
			min-height: 800px;
			background: #FBFBFB;
			border-radius: 12px;
			border: 1px solid #DFDFDF;
			margin-bottom: 100px;

			.ztBZ {

				width: 900px;
				height: auto;
				margin: 0 auto;

				border-left: 2px solid #ccc;
				position: relative;

				.zy {
					display: flex;
					position: absolute;
					left: -50px;
					top: 0;



					.ids {
						margin-top: -5px;

						width: 25px;
						height: 25px;
						background: #0F6CF5;
						text-align: center;
						line-height: 25px;
						border-radius: 50%;
						color: #fff;
					}
				}

				.title {
					font-weight: 600;
					font-size: 24px;
					color: #333333;
				}

				.recordList {
					width: 870px;
					height: 160px;
					background: #FFFFFF;
					border-radius: 12px;
					border: 1px solid #DFDFDF;
					margin: 20px auto;

					.recordList_box {
						width: 800px;
						height: 100px;

						display: flex;
						margin: 20px auto;


						.recordList_box_img {
							width: 148px;
							height: 100px;

							margin-right: 20px;

							img {
								width: 100%;
								height: 100%;
							}
						}

						.recordList_box_img1 {
							width: 68px;
							height: 71px;

							margin-left: 30px;
							margin-right: 60px;
						}

						.recordList_box_con {
							width: 540px;

							margin-right: 10px;

							.recordList_box_con1 {
								display: flex;
								width: 100%;
								height: 26px;
								line-height: 26px;
								margin-bottom: 10px;

								.con-type {
									text-align: center;
									width: 56px;
									height: 26px;
									background: #0F6CF5;
									border-radius: 6px;
									margin-right: 20px;
									color: #fff;
								}

								.con-type1 {
									background: #FF9645;
									color: #fff;
								}

								.con-name {
									width: 500px;
									font-weight: 600;
									font-size: 18px;
									color: #333333;
									white-space: nowrap;
									/* 防止文本换行 */
									overflow: hidden;
									/* 隐藏超出容器的内容 */
									text-overflow: ellipsis;
									/* 用省略号表示被截断的文本 */
								}
							}

							.recordList_box_con2 {
								width: 100%;
								height: 25px;

								font-weight: 400;
								font-size: 18px;
								color: #848F9A;
								line-height: 25px;
								margin-bottom: 15px;
							}

							.recordList_box_con3 {
								width: 100%;
								height: 22px;

								font-weight: 400;
								font-size: 16px;
								color: #848F9A;
								line-height: 22px;

							}


						}

						.recordList_box_btn {
							cursor: pointer;
							margin-top: 25px;
							width: 108px;
							height: 44px;
							border-radius: 6px;
							border: 1px solid #0F6CF5;
							font-weight: 400;
							font-size: 18px;
							color: #0F6CF5;
							line-height: 44px;
							text-align: center;
						}

						.recordList_box_btn1 {
							cursor: pointer;
							border: 1px solid #FF9645;
							background: #FF9645;
							color: #fff;
						}
					}
				}
			}
		}

		.right {
			width: auto;
			height: auto;


			ul>li {
				margin: 0;
				padding: 0;
				list-style: circle;
				cursor: pointer;
				width: auto;
				color: #ccc;
				margin-bottom: 20px;
				margin-left: 30px;
			}

			.liftActive {
				color: #000;
			}
		}

		.right1 {
			position: fixed;
			top: 100px;

			right: 480px;
			z-index: 99;
		}
	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1800px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 300px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1700px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 250px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1600px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 200px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1500px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 150px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1400px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 100px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1300px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 50px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1200px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 30px;


	}
}

/* 小屏幕设备，宽度小于600px */
@media screen and (max-width: 1200px) {

	/* 在这里应用适合小屏幕的样式 */
	.DetailsBox>.ztxx>.right1 {
		right: 0;
		background: #fff;

	}
}
</style>